import FieldSet from '../../FieldSet';

import { CreatedByImage } from './CreatedByImage';
import { CreatedByName } from './CreatedByName';

export class CreatedByFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [CreatedByImage, CreatedByName];
  }

  get title() {
    return 'Created by user';
  }
}
